const loadSloScroller = () => {
  const sloScroller = document.querySelector('.slo-scroller');
  const sloScrollerSingleContent = document.querySelector('.slo-scroller[data-variant="single-content"]');

  if (sloScroller && !sloScrollerSingleContent) {
    const sloScrollers = document.querySelectorAll('.slo-scroller');

    sloScrollers.forEach(sloScroller => {
      const scrollerImages = sloScroller.querySelectorAll('.slo-scroller--image');
      const scrollerContents = sloScroller.querySelectorAll('.slo-scroller--content');
      const scrollerThreshold = sloScroller.dataset.threshold ? sloScroller.dataset.threshold : .85;

      const options = {
        threshold: scrollerThreshold,
        rootMargin: '0px 0px 0px 0px'
      };

      const scrollerObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const index = Array.from(scrollerContents).indexOf(entry.target);
            scrollerImages.forEach(scrollerImage => scrollerImage.classList.remove('active'));
            scrollerImages[index].classList.add('active');
          }
        });
      }, options);

      scrollerContents.forEach(scrollerContent => {
        scrollerObserver.observe(scrollerContent);
      });
    });
  } else if (sloScrollerSingleContent) {
    const sloScrollers = document.querySelectorAll('.slo-scroller');

    sloScrollers.forEach(sloScroller => {
      const scrollerImages = Array.from(sloScroller.querySelectorAll('.slo-scroller--image'));
      const containerHeight = scrollerImages.reduce((acc, image) => {
        return acc + image.offsetHeight;
      }, 0);

      scrollerImages.forEach((image, index) => {
        const trigger = document.createElement('div');
        trigger.classList.add('slo-scroller--trigger');
        trigger.setAttribute('aria-label', `Scroller trigger ${index + 1}`);
        trigger.setAttribute('data-index', index + 1);
        trigger.style.setProperty('--trigger-height', `${image.offsetHeight}px`);
        sloScroller.appendChild(trigger);
      });

      sloScroller.style.setProperty('--container-height', `${containerHeight}px`);

      const options = {
        threshold: 0,
        rootMargin: '0px 0px -83% 0px'
      };

      const scrollerObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            sloScroller.classList.add('is-sticky');
          } else {
            sloScroller.classList.remove('is-sticky');
          }
        });
      }, options);

      scrollerObserver.observe(sloScroller);

      const triggers = sloScroller.querySelectorAll('.slo-scroller--trigger');

      triggers.forEach(trigger => {
        const triggerObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const index = entry.target.dataset.index;
              scrollerImages.forEach(image => image.classList.remove('active'));
              scrollerImages[index - 1].classList.add('active');
              const indicators = sloScroller.querySelectorAll('.slo-scroller--indicators li');
              if (indicators) {
                indicators.forEach(indicator => indicator.classList.remove('active'));
                indicators[index - 1].classList.add('active');
              }
            }
          });
        }, {
          threshold: .8
        });

        triggerObserver.observe(trigger);
      });
    });
  }
};

export default loadSloScroller;
